import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Dialog, Slide, Snackbar, IconButton } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import ThemedDialogActions from "./ThemedDialogActions";
import ThemedDialogContent from "./ThemedDialogContent";
import ThemedDialogTitle from "./ThemedDialogTitle";
import {
  DARK_THEME_BODY_COLOR,
  DARK_THEME_TEXT_COLOR,
  LIGHT_THEME_TEXT_COLOR,
  GENESIS_LOGO_COLOR,
} from "../../constants";
import CloseIcon from "@mui/icons-material/Close";
import MobileCreateProjectView from "../MobileCreateProjectView";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MobileCreateProjectDialog({
  open,
  handleClose,
  onCreateProject,
}) {
  const darkThemeEnabled = useSelector((state) => state.darkThemeEnabled);
  const [employees, setEmployees] = useState([]);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [createClicked, setCreateClicked] = useState(false);
  const [createLoading, setCreateLoading] = useState(false);

  useEffect(() => {
    if (open) {
      setCreateClicked(false);
      setCreateLoading(false);
      setSnackbarMessage("");
      // Fetch employees when dialog opens
      fetchEmployees();
    }
  }, [open]);

  const fetchEmployees = () => {
    import("../../req_utils").then(({ decoratedFetch }) => {
      decoratedFetch("/list_employees")
        .then((response) => {
          if (response.status !== 200) {
            return response.text().then((text) => {
              throw new Error(text);
            });
          }
          return response.json();
        })
        .then((data) =>
          setEmployees(data.filter((employee) => employee.enabled)),
        )
        .catch((error) => {
          console.error(`Error listing employees: ${error}`);
        });
    });
  };

  return (
    <>
      <Snackbar
        sx={{
          ".MuiSnackbarContent-root": {
            backgroundColor: GENESIS_LOGO_COLOR,
            minWidth: 0,
          },
        }}
        open={!!snackbarMessage}
        autoHideDuration={6000}
        onClose={() => setSnackbarMessage("")}
        message={snackbarMessage}
      />
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
        aria-labelledby="create-project-dialog-title"
      >
        <ThemedDialogTitle
          id="create-project-dialog-title"
          sx={{
            backgroundColor: darkThemeEnabled
              ? DARK_THEME_BODY_COLOR
              : "#f7f7f7",
            p: "8px 16px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                color: darkThemeEnabled
                  ? DARK_THEME_TEXT_COLOR
                  : LIGHT_THEME_TEXT_COLOR,
                fontSize: "1rem",
                fontWeight: "bold",
                marginRight: "18px",
              }}
            >
              Create Project
            </div>
            <div>
              <IconButton
                edge="start"
                color="inherit"
                onClick={handleClose}
                aria-label="close"
                style={{
                  color: darkThemeEnabled
                    ? DARK_THEME_TEXT_COLOR
                    : LIGHT_THEME_TEXT_COLOR,
                }}
              >
                <CloseIcon />
              </IconButton>
            </div>
          </div>
        </ThemedDialogTitle>
        <ThemedDialogContent
          sx={{
            backgroundColor: darkThemeEnabled
              ? DARK_THEME_BODY_COLOR
              : "#f7f7f7",
            p: 0,
          }}
        >
          <MobileCreateProjectView
            createClicked={createClicked}
            setCreateClicked={setCreateClicked}
            setCreateLoading={setCreateLoading}
            onCreateProject={onCreateProject}
            employees={employees}
            setSnackbarMessage={setSnackbarMessage}
          />
        </ThemedDialogContent>
        <ThemedDialogActions>
          <LoadingButton
            loading={createLoading}
            sx={{
              backgroundColor: createLoading ? "#565656 !important" : "auto",
            }}
            variant="contained"
            onClick={() => {
              setCreateLoading(true);
              setCreateClicked(true);
            }}
          >
            Create
          </LoadingButton>
        </ThemedDialogActions>
      </Dialog>
    </>
  );
}
